<script>
import Auth from '@/pages/layouts/auth.vue';
import Input from '@/pages/components/form/vertical/input.vue';
import {useForm} from '@inertiajs/vue3';

export default {
  components: {
    Auth,
    Input
  },
  methods: {
    submit() {
      this.form.post(route('password.confirm'), {
        onFinish: () => this.form.reset()
      });
    }
  },
  data() {
    return {
      form: useForm({
        'password': ''
      })
    }
  }
}
</script>

<template>
  <Auth title="Wachtwoord bevestigen">
    <p>Dit is een beveiligd gedeelte van de applicatie. Bevestig uw wachtwoord voordat u doorgaat.</p>

    <form class="form-horizontal form-material" @submit.prevent="submit">
      <Input v-model="form.password" :form="form" type="password" name="password" required placeholder="Wachtwoord"/>

      <div class="form-group">
        <button :disabled="form.processing" class="btn w-100 btn-lg btn-primary btn-rounded text-white" type="submit">Wachtwoord bevestigen</button>
      </div>
    </form>
  </Auth>
</template>